import { render, staticRenderFns } from "./policiesCenter.vue?vue&type=template&id=29c1d98c&scoped=true&"
import script from "./policiesCenter.vue?vue&type=script&lang=js&"
export * from "./policiesCenter.vue?vue&type=script&lang=js&"
import style0 from "./policiesCenter.vue?vue&type=style&index=0&id=29c1d98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c1d98c",
  null
  
)

export default component.exports